module.exports = __webpack_public_path__ + "assets/img/正骨.c764c98b.jpg";